(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["atelier-expanding-image-accordion"] && !Shopify.designMode) return;
  try {
    
  if (!customElements.get('atelier-image-accordion')) {
    customElements.define('atelier-image-accordion', class extends HTMLElement {
      constructor() {
        super();
        this.onPanelClick = this.onPanelClick.bind(this);
        this.onBlockSelect = this.onBlockSelect.bind(this);
      }

      connectedCallback() {
        this.panels = Array.from(this.querySelectorAll('[data-aia-panel]'));
        this.addEventListener('click', this.onPanelClick);
        this.addEventListener('shopify:block:select', this.onBlockSelect);
        const initialPanel = this.panels.find(panel => panel.classList.contains('is-active')) || null;
        this.setActivePanel(initialPanel);
      }

      disconnectedCallback() {
        this.removeEventListener('click', this.onPanelClick);
        this.removeEventListener('shopify:block:select', this.onBlockSelect);
      }

      onPanelClick(event) {
        const trigger = event.target.closest('[data-aia-trigger]');
        if (!trigger || !this.contains(trigger)) return;
        const panel = trigger.closest('[data-aia-panel]');
        if (!panel) return;

        if (panel.classList.contains('is-active')) {
          if (this.dataset.allowCollapse === 'true') this.setActivePanel(null);
        } else {
          this.setActivePanel(panel);
        }
      }

      onBlockSelect(event) {
        const panel = event.target.closest('[data-aia-panel]');
        if (panel && this.contains(panel)) this.setActivePanel(panel);
      }

      setActivePanel(activePanel) {
        const stage = this.querySelector('[data-aia-stage]');
        if (!stage) return;

        stage.classList.toggle('has-active', Boolean(activePanel));

        this.panels.forEach(panel => {
          const isActive = panel === activePanel;
          panel.classList.toggle('is-active', isActive);

          const trigger = panel.querySelector('[data-aia-trigger]');
          if (trigger) {
            trigger.setAttribute('aria-expanded', String(isActive));
            trigger.setAttribute('aria-label', isActive ? trigger.dataset.closeLabel : trigger.dataset.openLabel);
          }

          const details = panel.querySelector('[data-aia-details]');
          if (details) details.setAttribute('aria-hidden', String(!isActive));

          panel.querySelectorAll('[data-aia-link]').forEach(link => {
            if (isActive) link.removeAttribute('tabindex');
            else link.setAttribute('tabindex', '-1');
          });
        });
      }
    });
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
